<template>
  <div class="vuse-content-wrapper">
    <div v-if="hasAccess('timeOff')">
      <vuse-section-definition
        :title="`Time Off`"
        icon="mdi-calendar"
      ></vuse-section-definition>
      <v-container fluid class="">
        <v-card :loading="loading">
          <v-card-title class="d-flex justify-space-around">
            <v-btn fab text small color="grey darken-2" @click="prev">
              <v-icon small> mdi-chevron-left </v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-btn fab text small color="grey darken-2" @click="next">
              <v-icon small> mdi-chevron-right </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row class="d-flex">
              <v-col @click="newTask()" v-show="hasAccess('timeOff.add')">
                <v-btn outlined class="mr-2" block color="info">
                  <v-icon>add</v-icon> Request Time Off
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  outlined
                  block
                  class="mr-2"
                  color="grey darken-2"
                  @click="setToday"
                >
                  Today
                </v-btn>
              </v-col>
              <v-col>
                <v-menu bottom right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      block
                      outlined
                      color="grey darken-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <span>{{ typeToLabel[type] }}</span>
                      <v-icon right> mdi-menu-down </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="type = 'day'">
                      <v-list-item-title>Day</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = 'week'">
                      <v-list-item-title>Week</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = 'month'">
                      <v-list-item-title>Month</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="hasAccess('timeoff.edit') && type !== 'month'">
                <v-switch v-model="editable" label="Draggable mode" />
              </v-col>

              <v-col>
                <v-text-field v-model="keyword" label="Search" clearable />
              </v-col>
            </v-row>
            <v-row class="fill-height">
              <v-col>
                <v-sheet height="600" v-if="!keyword">
                  <v-calendar
                    ref="calendar"
                    v-model="focus"
                    color="primary"
                    :events="events"
                    :event-color="getEventColor"
                    :type="type"
                    @click:more="viewDay"
                    @click:date="viewDay"
                    @click:event="showEvent"
                    @change="updateRange"
                    @mousedown:event="startDrag"
                    @mousedown:time="startTime"
                    @mousemove:time="mouseMove"
                    @mouseup:time="endDrag"
                    @mouseleave.native="cancelDrag"
                  >
                    <template v-slot:event="{ event, timed, timeSummary }">
                      <div class="v-event-draggable">
                        <v-row>
                          <v-col
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                            class="d-flex justify-content-between"
                          >
                            <div style="margin: 2px 5px">
                              <v-menu offset-y v-if="false">
                                <template v-slot:activator="{ on }">
                                  <v-btn dark v-on="on" x-small icon>
                                    <v-icon>mdi-dots-vertical</v-icon>
                                  </v-btn>
                                </template>
                                <v-list>
                                  <v-list-item @click="editEvent(event)" dense>
                                    <v-list-item-title> Edit</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item
                                    @click="deleteEvent(event)"
                                    v-if="
                                      event &&
                                      typeof event.id == 'undefined' &&
                                      !event.saved
                                    "
                                    dense
                                  >
                                    <v-list-item-title>
                                      Cancel</v-list-item-title
                                    >
                                  </v-list-item>
                                  <v-list-item
                                    @click="saveEvent(event)"
                                    dense
                                    v-if="
                                      event &&
                                      event.id &&
                                      !event.saved &&
                                      editable
                                    "
                                  >
                                    <v-list-item-title> Save</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </div>
                            <div style="margin: 2px 5px" v-show="event.userId">
                              <UsersChip :value="event.employee" size="25" />
                            </div>
                            <div
                              style="margin: 2px 5px"
                              v-if="
                                typeof event.id === 'undefined' || !event.saved
                              "
                            >
                              <v-chip
                                v-if="!event.saved"
                                @click="editEvent(event)"
                                x-small
                                class="ml-1"
                                icon
                                ><v-icon>mdi-pencil</v-icon>
                              </v-chip>

                              <v-btn
                                v-if="!event.saved && !event.id"
                                @click="deleteEvent(event)"
                                x-small
                                class="ml-1"
                                icon
                                ><v-icon>mdi-close</v-icon>
                              </v-btn>

                              #{{ event.id }} - {{ timeSummary() }}
                            </div>
                            <div v-else style="margin: 2px 5px">
                              #{{ event.id }} - {{ 
                                event.isAllDay 
                                ? '6AM - 2:30PM'
                                : timeSummary() }}
                            </div>
                          </v-col>
                        </v-row>

                        <div
                          v-if="timed && editable"
                          class="v-event-drag-bottom"
                          @mousedown.stop="extendBottom(event)"
                          @mouseleave.end="endExtendBottom(event)"
                        ></div>
                      </div>
                    </template>
                  </v-calendar>
                </v-sheet>

                <v-sheet v-else>
                  Search Result of "{{ keyword }}"
                  <v-row>
                    <v-col>
                      <v-data-table
                        :headers="calendarHeaders"
                        :items="events"
                        class="elevation-1"
                        :loading="loading"
                        :item-class="itemRowBackground"
                        :disable-pagination="true"
                      >
                        <template v-slot:item.userFirstName="{ item }">
                          <UsersChip :value="item.employee" />
                        </template>

                        <template v-slot:item.startDate="{ item }">
                          <v-chip x-small>{{
                            item.startDate | formatDatetime
                          }}</v-chip>
                        </template>

                        <template v-slot:item.endDate="{ item }">
                          <v-chip x-small>{{
                            item.endDate | formatDatetime
                          }}</v-chip>
                        </template>

                        <template v-slot:item.action="{ item }">
                          <v-menu offset-y v-if="editable">
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" x-small icon>
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item @click="editEvent(item)" dense>
                                <v-list-item-title> Edit</v-list-item-title>
                              </v-list-item>
                              <v-list-item
                                @click="deleteEvent(item)"
                                v-if="
                                  item &&
                                  typeof item.id == 'undefined' &&
                                  !item.saved
                                "
                                dense
                              >
                                <v-list-item-title> Cancel</v-list-item-title>
                              </v-list-item>
                              <v-list-item
                                @click="saveEvent(item)"
                                dense
                                v-if="
                                  item && item.id && !item.saved && editable
                                "
                              >
                                <v-list-item-title> Save</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>

      <TimeOffForm
        :show="selectedOpenScheduling"
        :item="selectedEvent"
        @onClosed="clearTask()"
        @onSucceded="refreshCalendar()"
        :isDraggable="editable"
      />
    </div>

    <NoPermission v-else />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import TimeOffForm from "src/views/Pages/TimeOff/_Form";
import formatterMixin from "@/mixins/formatterMixin";
import UsersChip from "components/UsersChip";
import store from "src/store";
import NoPermission from "components/NoPermission";

const defaultHeaders = [
  { text: "Action", value: "action", sortable: false, active: true },
  { text: "Employee", value: "employeeFirstName", active: true },
  { text: "Status", value: "status", sortable: true, active: true },
  {
    text: "Reason",
    value: "reason",
    sortable: true,
    active: true,
  },
  { text: "Start", value: "startDate", sortable: true, active: true },
  { text: "End", value: "endDate", sortable: true, active: true },
];

export default {
  mixins: [formatterMixin],
  components: {
    TimeOffForm,
    UsersChip,
    NoPermission,
  },
  data: () => ({
    calendarHeaders: defaultHeaders,
    editable: false,
    loading: false,
    focus: new Date(),
    keyword: "",
    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    selectedOpenScheduling: false,
    events: [],
    colors: ["#FFCC00"],
    dragEvent: null,
    dragEventOld: null,
    dragStart: null,
    createEvent: null,
    createStart: null,
    extendOriginal: null,
  }),
  async mounted() {
    this.$refs.calendar.checkChange();
    await this.refresh();
  },
  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      task: (state) => state.task.data,
      items: (state) => state.timeOff.data,
      account: (state) => state.account.data.user,
    }),
  },
  watch: {
    async keyword(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        await this.refresh({ SearchTerm: newValue });
      }
    },
  },
  methods: {
    ...mapActions({
      getAll: "timeOff/getAll",
    }),
    switchFocus(item) {
      this.focus = this.formatDatetime(item.date);
      this.keyword = "";
      this.type = "day";
    },

    itemRowBackground(item) {
      return item.color;
    },

    newTask() {
      let initDateTime = this.focus;
      if (this.focus && this.focus.length === 10) {
        initDateTime = this.focus + " " + this.momentLocal().format("HH:mm");
      }
      let utcDate = this.localToUtc(initDateTime);
      this.addTask({
        startDate: utcDate,
        endDate: utcDate,
        status: "open",
      });
    },

    async refreshCalendar() {
      const { lastEnd, lastStart } = this.$refs.calendar;
      this.$refs.calendar.$emit("change", {
        start: lastStart,
        end: lastEnd,
      });

      await this.refresh();
    },
    async refresh(payload) {
      await this.getAll(payload);
      this.loading = true;
      this.events = [];
      this.items

        .filter((timeOff) => {
          // only show mime (user logged in)
          if (!this.hasAccess("timeOff.view")) {
            return this.account && timeOff.userId === this.account.id;
          } else {
            return true;
          }
        })
        .map((task) => {
          let startDateTime = task.startDate;
          let endDateTime = task.endDate;

          let color = "#CFCFCF";
          if (task.status == "approved") {
            color = "#1665C1";
          } else if (task.status == "denied") {
            color = "#ff0000";
          }
          this.events.push({
            ...task,
            employee: [
              {
                userFirstName: task.employeeFirstName,
                userLastName: task.employeeLastName,
              },
            ],
            color,
            timed: 1,
            start: this.momentLocal(startDateTime).toDate().getTime(), // timestamp
            end: this.momentLocal(endDateTime).toDate().getTime(), // timestamp
            saved: true,
            savedStatus: "Saved",
          });
        });
      this.loading = false;
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    clearTask() {
      this.selectedEvent = {};
      this.selectedOpen = false;
      this.selectedOpenScheduling = false;
    },
    addTask(initialValue = {}, show = true) {
      this.selectedEvent = initialValue;
      this.selectedOpenScheduling = show;
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },

    editEvent(event) {
      this.selectedEvent = event;
      this.selectedOpenScheduling = true;
    },

    saveEvent(event) {
      // this.addTask(event, true);
      store
        .dispatch("task/update", {
          task: {
            ...event,
            date: event.date.replace(" ", "T") + "Z",
            endDate: event.endDate.replace(" ", "T") + "Z",
          },
          id: event.id,
        })
        .then(() => {
          let i = this.events.indexOf(event);
          this.events[i].saved = true;
        });
    },

    deleteEvent(event) {
      if (window.confirm("Are you sure will cancel this job?")) {
        const i = this.events.indexOf(event);
        if (i !== -1) {
          this.events.splice(i, 1);
        }
      }
    },

    showEvent({ nativeEvent, event }) {
      // if (this.editable) {
      //   return false;
      // }
      const open = () => {
        this.selectedEvent = { ...event, name: event.originalName };
        this.selectedElement = nativeEvent.target;
        setTimeout(() => {
          this.selectedOpenScheduling = true;
        }, 10);
      };
      if (typeof event.id !== "undefined") {
        if (this.selectedOpenScheduling) {
          this.selectedOpenScheduling = false;
          setTimeout(open, 10);
        } else {
          open();
        }
      }

      nativeEvent.stopPropagation();
    },
    async updateRange({ start, end }) {
      let payload = {
        dateStart: this.momentLocal(start.date)
          .subtract(10, "month")
          .format("YYYY-MM-DD"),
        dateEnd: this.momentLocal(end.date)
          .add(1, "month")
          .format("YYYY-MM-DD"),
        PageSize: 1000,
      };
      await this.refresh(payload);
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    // test like google-calendar

    startDrag({ event, timed }) {
      if (event && timed && this.editable) {
        this.dragEvent = event;
        this.dragEventOld = event;
        this.dragTime = null;
        this.extendOriginal = null;
      }
    },

    /**
     * @param tms Date
     */
    startTime(tms) {
      if (!this.editable) {
        return false;
      }
      const mouse = this.toTime(tms);
      // in dragging mode
      if (this.dragEvent && this.dragTime === null) {
        const start = this.dragEvent.start;
        this.dragTime = mouse - start;
      } else if (this.hasAccess("timeoff.add")) {
        this.createStart = this.toTime(tms);
        this.createEvent = {
          color: "#CFCFCF",
          startDate: this.localToUtc(new Date(this.createStart)),
          endDate: this.localToUtc(new Date(this.createStart)),
          start: this.createStart,
          end: this.createStart,
          timed: 1,
          status: "requested",
          saved: false,
        };
        // this.events.push(this.createEvent);
        this.editEvent(this.createEvent);
      }
    },

    extendBottom(event) {
      console.log("EXTEND_BOTTOM");
      this.createEvent = event;
      this.createStart = event.start;
      this.extendOriginal = event.end;
    },

    endExtendBottom(event) {
      // let self = this;
      // _.debounce((old) => {
      //   store
      //     .dispatch("task/update", {
      //       task: {
      //         ...old,
      //         date: old.date.replace(" ", "T") + "Z",
      //         endDate: old.endDate.replace(" ", "T") + "Z",
      //       },
      //       id: old.id,
      //     })
      //     .then(() => {
      //       self.events = self.events.map((event) => {
      //         return {
      //           ...event,
      //           saved: true,
      //         };
      //       });
      //     });
      // }, 1000)(event);

      console.log("EXTEND BOTTOM", event);
    },

    mouseMove(tms) {
      // console.log('MOUSE_MOVE');
      const mouse = this.toTime(tms);
      if (this.dragEvent && this.dragTime !== null) {
        let start = this.dragEvent.start;
        let end = this.dragEvent.end;

        if (typeof start !== "number") {
          start = new Date(start).getTime();
        }

        if (typeof end !== "number") {
          end = new Date(end).getTime();
        }

        const duration = end - start;
        const newStartTime = mouse - this.dragTime;
        const newStart = this.roundTime(newStartTime);
        const newEnd = newStart + duration;
        this.dragEvent.start = newStart;
        this.dragEvent.end = newEnd;
        this.dragEvent.startDate = this.localToUtc(new Date(newStart));
        this.dragEvent.endDate = this.localToUtc(new Date(newEnd));

        this.dragEvent.saved = false;
        this.dragEvent.savedStatus = "Not saved";
        console.log("END MOVED");
      } else if (this.createEvent && this.createStart !== null) {
        const mouseRounded = this.roundTime(mouse, false);

        let createStart = this.createStart;
        if (typeof createStart !== "number") {
          this.createStart = new Date(createStart).getTime();
        }

        const min = Math.min(mouseRounded, this.createStart);
        const max = Math.max(mouseRounded, this.createStart);

        this.createEvent.start = min;
        this.createEvent.end = max;

        this.createEvent.startDate = this.localToUtc(new Date(min));
        this.createEvent.endDate = this.localToUtc(new Date(max));
        this.createEvent.saved = false;
        this.createEvent.savedStatus = "Not saved";
      }
    },
    endDrag() {
      // if (this.dragEvent && typeof this.dragEvent.id !== 'undefined') {
      //     if (confirm("Want to save this changes?")) {
      //       console.log(this.dragEvent);
      //     }
      //   }

      console.log(this.dragEvent);

      this.dragTime = null;
      this.dragEvent = null;
      this.createEvent = null;
      this.createStart = null;
      this.extendOriginal = null;
      console.log("END DRAG");
    },
    cancelDrag() {
      // console.log("CANCEL DRAG");
      // console.log("CANCEL DRAG CREATE EVENT", this.createEvent);

      if (this.createEvent) {
        if (this.extendOriginal) {
          this.createEvent.end = this.extendOriginal;
        } else {
          const i = this.events.indexOf(this.createEvent);
          if (i !== -1) {
            this.events.splice(i, 1);
          }
        }
      }

      this.createEvent = null;
      this.createStart = null;
      this.dragTime = null;
      this.dragEvent = null;
    },
    roundTime(time, down = true) {
      const roundTo = 15; // minutes
      const roundDownTime = roundTo * 60 * 1000;

      return down
        ? time - (time % roundDownTime)
        : time + (roundDownTime - (time % roundDownTime));
    },

    /**
     * @return Date local timezone
     */
    toTime(tms) {
      return new Date(
        tms.year,
        tms.month - 1,
        tms.day,
        tms.hour,
        tms.minute
      ).getTime();
    },
    rndElement(arr) {
      return arr[this.rnd(0, arr.length - 1)];
    },
  },
};
</script>


<style scoped lang="scss">
.v-event-draggable {
  padding-left: 6px;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 16px;
    margin-left: -8px;
    opacity: 0.8;
    content: "";
  }

  &:hover::after {
    display: block;
  }
}
</style>